module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av312-9936f5a77bc329f53ed40f4b0230e48c.jpg";